import axios from 'axios';
import { attachAuth } from '@/utils/authSession';

// const apiClient = axios.create({
//   baseURL: process.env.VUE_APP_API_BASE_URL || "http://localhost:9000/",
//   headers: {
//     Accept: 'application/json',
//     'Content-Type': 'application/json',
//   }
// });

const apiAuthClient = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || "http://localhost:9000",
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  }
});

attachAuth(apiAuthClient, { optional: false });

export default {
    sendFriendRequest(FriendRequest){
        return apiAuthClient.post(`/sendFriendRequest`, FriendRequest)
    }, 
    acceptFriendRequest(userRequestorId){
        return apiAuthClient.put(`/acceptFriendRequest/${userRequestorId}`)
    },
    deleteFriendRequest(requestee_id){
        return apiAuthClient.delete(`/deleteFriendRequest/${requestee_id}`)
    },
    listFriendRequsts(){
        return apiAuthClient.get('/friendRequests')
    },
    listPendingFriendRequests(){
        return apiAuthClient.get('/pendingFriendRequests')
    },
    listFriends(){
        return apiAuthClient.get('/friends')
    },
    getAllUsers(){
        return apiAuthClient.get('/getAllUsers')
    },
    //FOLLOWING
    followSomeone(follow){
        return apiAuthClient.post('/followSomeone', follow)
    },
    getPeopleFollowing(){
        return apiAuthClient.get('/getPeopleFollowing')
    },
    unFollowSomeone(userFollowedId){
        return apiAuthClient.post(`/followSomeone/${userFollowedId}`)
    }
}